import type { SVGProps } from 'react';

const SvgRaApprovedByMe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 10c-.55 0-1-.45-1-1V5.23c0-.73-.47-1.39-1.17-1.62a1.71 1.71 0 0 0-2.21 1.28l-.08.54a8.2 8.2 0 0 1-2.84 5.05c-.45.37-.69.93-.69 1.51v6.06c0 1.1.9 2 2 2h7.61c1.29 0 2.44-.83 2.85-2.05l1.44-5.37a2 2 0 0 0-1.9-2.63zm-11.5.5c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5S6 18.83 6 18v-6c0-.83-.67-1.5-1.5-1.5"
    />
  </svg>
);
export default SvgRaApprovedByMe;
